import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CustomLabel6 } from '@4beefopag/4bee-fopag-core/dist/atoms';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { Popover } from 'antd';
import { moneyFormat } from '@4beefopag/4bee-fopag-core/dist/util';

function AdiantamentoHeader({ parametrizacao = {} }) {
  if (!parametrizacao.exibe_param_apontamento || !parametrizacao.adiantamento_auto) {
    return (
      <th width="128px">
        <CustomLabel6>Adiantamento</CustomLabel6>
      </th>
    );
  }

  let popoverMessage = `${moneyFormat(parametrizacao.adiantamento_auto_valor)} de Valor Fixo`;
  if (parametrizacao.adiantamento_auto_id_tipo === 1) {
    popoverMessage = `${parametrizacao.adiantamento_auto_valor}% do valor de Remuneração Base do colaborador`;
  }

  return (
    <th width="128px">
      <CustomLabel6>Adiantamento</CustomLabel6>
      <Popover
        title="Valores Parametrização"
        content={popoverMessage}
      >
        <FontAwesomeIcon
          data-testid="popover-adiantamento-trigger"
          icon={faInfoCircle}
          size="sm"
          style={{ marginLeft: '8px' }}
        />
      </Popover>
    </th>
  );
}

AdiantamentoHeader.propTypes = {
  parametrizacao: PropTypes.shape(),
};

AdiantamentoHeader.defaultProps = {
  parametrizacao: {},
};

export default AdiantamentoHeader;
